import { createFileRoute } from '@tanstack/react-router';

import { settingsQueryOptions } from '@/features/notifications/api';
import { NotificationSettingsPage } from '@/features/notifications/settings-page';

export const Route = createFileRoute('/_app/settings/notifications')({
  loader: ({ context }) => context.queryClient.query({ ...settingsQueryOptions, staleTime: 0 }),
  component: NotificationSettingsPage,
});
